import React from 'react'
import useAtmosphere from '~/hooks/useAtmosphere'
import DeleteCommentMutation from '~/mutations/DeleteCommentMutation'

import Menu from './Menu'
import MenuItem from './MenuItem'
import MenuItemWithIcon from './MenuItemWithIcon'








const CommentAuthorOptionsDropdown = (props) => {
  const {commentId, editComment, meetingId, menuProps} = props
  const atmosphere = useAtmosphere()
  const deleteComment = () => {
    DeleteCommentMutation(atmosphere, {commentId, meetingId})
  }
  return (
    React.createElement(Menu, { ariaLabel: 'Select the action for your comment', ...menuProps,}
      , React.createElement(MenuItem, {
        label: React.createElement(MenuItemWithIcon, { dataCy: "edit-comment", label: 'Edit Comment', icon: 'edit',} ),
        onClick: editComment,}
      )
      , React.createElement(MenuItem, {
        label: 
          React.createElement(MenuItemWithIcon, { dataCy: "delete-comment", label: 'Delete Comment', icon: 'delete',} )
        ,
        onClick: deleteComment,}
      )
    )
  )
}

export default CommentAuthorOptionsDropdown
